import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-eye-closed",
  "use": "n-icon-eye-closed-usage",
  "viewBox": "0 0 15 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 10\" id=\"n-icon-eye-closed\">\n    <path d=\"M8 0c4.2 0 7 4 7 5s-2.8 5-7 5-7-4-7-5 2.8-5 7-5Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z\" fill=\"currentColor\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.73.58a.5.5 0 0 1-.15.69L1.42 9.73a.5.5 0 1 1-.54-.842L14.039.43a.5.5 0 0 1 .69.15Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol